import type { Pair } from '../messages';

/** Navigation chrome: the app tab bar, the public top bar and the actions inside them. */
export const nav = {
  'nav.feed': ['Лента', 'Feed'],
  'nav.library': ['Библиотека', 'Library'],
  'nav.playlists': ['Подборки', 'Collections'],
  'nav.profile': ['Профиль', 'Profile'],
  'nav.sections': ['Разделы', 'Sections'],
  'nav.main': ['Основные разделы', 'Main sections'],
  'nav.search': ['Поиск', 'Search'],
  'nav.settings': ['Настройки', 'Settings'],
  'nav.add': ['Добавить', 'Add'],
  'nav.addLink': ['Добавить ссылку', 'Add a link'],
  'nav.skip': ['К основному содержимому', 'Skip to content'],
  'nav.yourProfile': ['Ваш профиль', 'Your profile'],
  'nav.enter': ['Войти', 'Sign in'],
  'nav.start': ['Начать', 'Start'],
  'nav.toLibrary': ['В библиотеку', 'Open library'],
  'nav.about': ['О проекте', 'About'],
} satisfies Record<string, Pair>;
